import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import MultiSelect from '../../common/Forms/MultiSelect';

const PackageSelect = ({ options, selectedValues }) => {
  const [selectedOptions, setSelectedOptions] = useState(selectedValues);

  const handleChange = (options) => {
    setSelectedOptions(options);
  };

  return (
    <div style={ { width: '300px' } }>
      <input name="coupon[package_ids]"
             value={selectedOptions.map(option => option.value)}
             hidden/>
      <MultiSelect
        handleChange={handleChange}
        options={options}
        selectedValues={selectedValues}
        placeholderText='Select Pricelists'
      />
    </div>
  );
};

PackageSelect.propTypes = {
  options: PropTypes.array,
  selectedValues: PropTypes.array
};

PackageSelect.defaultProps = {
  options: [{}],
  selectedValues: [{}]
};

export default PackageSelect;
